
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/propleaf",
      function () {
        return require("private-next-pages/case-study/propleaf.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/propleaf"])
      });
    }
  